if (!customElements.get('cart-page')) {
  class CartPage extends HTMLElement {
    constructor() {
      super();

      this.bindEvents();
    }

    bindEvents() {
      this.toggleNote();
      this.submitForm();
    }

    submitForm() {
      const cartSubmit = this.querySelector('.js-cart-submit'),
        cartCheckout = this.querySelector('.js-cart-checkout');

      if (!cartSubmit || !cartCheckout) return;

      cartSubmit.addEventListener('click', () => {
        cartCheckout.click();
      });
    }

    toggleNote() {
      const cartToggle = this.querySelector('.js-cart-note'),
        cartTextarea = this.querySelector('.js-cart-textarea');
      if (!cartToggle || !cartTextarea) return;

      cartToggle.addEventListener('click', () => {
        cartTextarea.classList.toggle('is-open');
        cartTextarea.style.maxHeight
          ? (cartTextarea.style.maxHeight = null)
          : (cartTextarea.style.maxHeight = cartTextarea.scrollHeight + 'px');
      });
    }
  }

  customElements.define('cart-page', CartPage);
}
